<div class="attachment-dialog">
  <tui-scrollbar class="attachment-dialog__preview-scrollbar">
    <!-- TODO: заменить на  app-images-group-view -->
    <chat-attachment-preview [attachmentPreview]="attachmentsPreview"></chat-attachment-preview>
  </tui-scrollbar>

  <message-input
    class="attachment-dialog__input"
    [floatingToolbar]="!isMobile"
    [invalid]="isInputAreaInvalid"
    [placeholder]="'components.telegramAttachment.fields.signature' | translate"
    [(message)]="messageText"
    (onEnterKeyPressed)="onClickConfirmAttachment()"
  ></message-input>

  <button tuiButton type="button" size="m" class="tui-space_right-3" (click)="onClickConfirmAttachment()">
    {{ 'common.buttons.send' | translate }}
  </button>

  <button tuiButton type="button" appearance="secondary" size="m" (click)="observer?.complete()">
    {{ 'common.buttons.cancellation' | translate }}
  </button>
</div>
